import { render, staticRenderFns } from "./FiltroPorNivelDeEstoque.vue?vue&type=template&id=0d41ff13&scoped=true"
import script from "./FiltroPorNivelDeEstoque.vue?vue&type=script&lang=js"
export * from "./FiltroPorNivelDeEstoque.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d41ff13",
  null
  
)

export default component.exports